import React, { Fragment, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";

import Collapse from "./Collapse";
import { getOptionLabel } from "common/enums";

const AutomaticSprinklerSystemView = ({
  sprinklers,
  isExpandable = true,
  isBasement = false,
  floorOptions = [],
  t,
}) => {
  const fields = useMemo(
    () => [
      {
        name: "Sprinkler Type",
        key: "sprinklerType",
        renderField: (value) =>
          value ? getOptionLabel("sprinklerTypeEnum", value) : "-",
      },
      {
        name: isBasement ? "Basement" : "Floor",
        key: "floorId",
        renderField: (value) =>
          floorOptions.find(({ id }) => id === value)?.name ?? "-",
      },
      {
        name: "Quantity",
        key: "quantity",
        isRequired: true,
      },
    ],
    [floorOptions, isBasement]
  );

  return (
    <>
      <Collapse
        title={isBasement ? "Basement Sprinklers" : "Floor Sprinklers"}
        isExpandable={isExpandable}
      >
        {sprinklers.map((sprinkler, index) => (
          <Fragment key={sprinkler.id}>
            <Row className="d-flex  mb-2">
              <label className="fw-semibold">
                {t(isBasement ? "Basement Sprinkler" : "Floor Sprinkler") +
                  " : " +
                  (index + 1)}
              </label>
              {fields.map(({ name, key, isRequired, renderField }) => {
                const value = get(sprinkler, key, "");

                return (
                  <Col key={key} lg={6} className="mb-1">
                    <Row>
                      <Col md={5}>{t(name)}:</Col>
                      <Col
                        md={7}
                        className="fw-semibold"
                        style={{ wordBreak: "break-word" }}
                      >
                        {renderField
                          ? renderField(value)
                          : get(sprinkler, key, null) ??
                            (isRequired ? "-" : "N/A")}
                      </Col>
                    </Row>
                  </Col>
                );
              })}
            </Row>
          </Fragment>
        ))}
      </Collapse>
    </>
  );
};

AutomaticSprinklerSystemView.propTypes = {
  sprinklers: PropTypes.array,
  isExpandable: PropTypes.bool,
  floorOptions: PropTypes.array,
  isBasement: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(AutomaticSprinklerSystemView);
